import { EntityId } from '@reduxjs/toolkit';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { UserStorage } from 'src/entities/user';
import { CatalogItemViewStorageState } from './types';

export class CatalogItemViewService extends UserStorage<CatalogItemViewStorageState> {
  #defaultState: Record<CatalogItemType, EntityId[]> = {
    [CatalogItemType.Resume]: [],
    [CatalogItemType.Vacancy]: [],
  };

  addAccessOfItem(id: EntityId, catalogType = CatalogItemType.Resume) {
    const accessOfItems = this.getAccessOfItems();
    if (Array.isArray(accessOfItems) || accessOfItems[catalogType].includes(id)) {
      return;
    }
    this.setUserStorage({
      accessOfItems: {
        ...accessOfItems,
        [catalogType]: [...accessOfItems[catalogType], id],
      },
    });
  }

  getAccessOfItems<T = Record<CatalogItemType, EntityId[]> | EntityId[]>(catalogType?: CatalogItemType): T {
    const accessOfItems = this.storage.getItem()?.accessOfItems || this.#defaultState;
    return (catalogType ? accessOfItems[catalogType] : accessOfItems) as T;
  }
}
